import axios from "axios";
import { BASE_URL, SIGN_UP_DEALER_URL } from "@/utils/api/Urls";

/**
 * Post  become dealer data
 */
export const signUpDealer = async (
  data: IBecomeDealerForm,
  captcha: ICaptchaValid
) => {
  const requestURL = `${BASE_URL}${SIGN_UP_DEALER_URL}`;

  try {
    const headers = {
      "Content-Type": "application/json",
      "Captcha-Input": captcha.value,
    };
    const response = await axios.post(requestURL, data, { headers });
    return response;
  } catch (err: unknown) {
    // Axios error
    if (axios.isAxiosError(err)) {
      // The request was made and the server responded with a status code
      if (err.response) {
        console.log("Error status:", err.response.status);
        return err.response;
      }

      // The request was made but no response was received
      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }

    // Non-Axios error
    console.log("Non-Axios error occurred:", err);
  }
};
